<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div class="text-center">
        <h2 class="mt-6 text-3xl font-extrabold text-gray-900">Forgot your password?</h2>
        <p class="mt-2 text-sm text-gray-600">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      <div class="mt-8">
        <ForgotPasswordForm />
      </div>

      <div class="text-center">
        <router-link
          to="/auth/login"
          class="font-medium text-blue-600 hover:text-blue-500 transition-colors inline-flex items-center gap-1"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Back to sign in
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { useAuth } from '@/features/auth/composables/useAuth';
  import { ForgotPasswordForm } from '@/features/auth/components';

  const router = useRouter();
  const { isAuthenticated } = useAuth();

  // Redirect if already authenticated
  onMounted(() => {
    if (isAuthenticated.value) {
      router.push('/app');
    }
  });
</script>
